import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { SolicitudService } from 'app/services/solicitud.service';
import { AlcanceTitulosComponent } from './alcance-titulos/alcance-titulos.component';
import { HistorialComponent } from './historial/historial.component';

@NgModule({
  imports: [
    CommonModule,
  ],
  declarations: [AlcanceTitulosComponent, HistorialComponent],
  providers:[SolicitudService]
})
export class GeneralModule { }



// WEBPACK FOOTER //
// /app/src/app/modules/general/general.module.ts